<template>
  <SplitHeroCta v-bind="payload" />
</template>

<script>
import SplitHeroCta from './index.vue'

export default {
    name: 'SplitHeroCtaCraft',
    components: {
        SplitHeroCta,
    },
    computed: {
        payload() {
            let filtered = {}

            for (const [key, value] of Object.entries(this.$attrs)) {
                filtered = {
                    ...filtered,
                    [key]: JSON.parse(value)
                }
            }

            return filtered
        }
    }
}
</script>